export default {
  NODE_ENV: 'production',
  ENDPOINTS: {
    CAT4MRO: 'https://cat4mro-qa.herokuapp.com/v1/graphql',
  },
  IDENTITY: {
    AUTHORITY: 'https://qa-identityadminsts.ulinksolution.com',
    REDIRECT_URI: 'https://qa.cat4mro.com/static/callback.html',
    SILENT_REDIRECT_URI: 'https://qa.cat4mro.com/static/silent-renew.html',
    POST_LOGOUT_REDIRECT_URI: 'https://cat4mro.com',
  },
  ApplicationInsightsKey: '8edf663c-5c5c-4e12-aea2-cb3e1d78362c',
};



// WEBPACK FOOTER //
// ./src/config/env.production.js